import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { EinvoiceSubmissionHistoryExportFileContainerModel } from "../../../../../../models/aggregates/erp/einvoice-submission-history-export/einvoice-submission-history-export-container.model";

@Injectable({ providedIn: "root" })
export class EinvoiceSubmissionExportService extends BaseApiTemplateService<EinvoiceSubmissionHistoryExportFileContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "export/einvoice-submission-history-file-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "export/einvoice-submission-history-file-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}